// Product streams are ascending. Polling only their first page would never
// discover later rows once that page fills. Return a bounded window and its
// continuation, never report a volume limit as a failed read.
export async function readForwardPages(readPage, { field, id, cursorField, start = 0, limit = 100, maxPages = 10, signal }) {
  const rows = new Map();
  let after = start;
  for (let index = 0; index < maxPages; index++) {
    signal?.throwIfAborted();
    const page = await readPage(after, limit);
    signal?.throwIfAborted();
    const items = page[field] ?? [];
    for (const item of items) rows.set(item[id], item);
    // Inbox has no hasMore, but a short page proves the current end.
    const more = page.hasMore ?? items.length === limit;
    if (!more) return { ...page, [field]: [...rows.values()], hasMore: false, incomplete: false };
    const next = page[cursorField];
    if (next == null || BigInt(next) <= BigInt(after)) throw new Error('기록을 다시 확인해 주세요.');
    if (index + 1 === maxPages) return { ...page, [field]: [...rows.values()], hasMore: true, incomplete: true };
    after = next;
  }
}
